import { enUS, sv, type Locale as DateFnsLocale } from 'date-fns/locale';
import type { Locale } from '@financialharmony/i18n';
import { useFormatters } from '@financialharmony/ui';
import { formatRelativeDate } from '@/utils/dateUtils';

// A `Record<Locale, …>` so a language cannot be added to the shared list without choosing its date-fns words.
const DATE_FNS_LOCALES: Record<Locale, DateFnsLocale> = { en: enUS, sv };

/** `formatRelativeDate` ("2 hours ago" / "14 Apr") in the language the app shows. */
export function useFormatRelativeDate() {
  const { locale } = useFormatters();
  const dateFnsLocale = DATE_FNS_LOCALES[locale];
  return (dateString: string) => formatRelativeDate(dateString, dateFnsLocale);
}
